@if(data(); as data) {
    <div [id]="data.id">
        <div class="padding-1 clip5 primary-gradient-bg-100 rounded-1 img-box">
            <div class="clip5 flip-card-front overflow-hidden rounded-1">
                <div (click)="addToBreadCrumb(data)" class="user-card p-2 d-flex flex-column rounded-1  img-container">

                    @if (!data.hasImageError()) {
                        <img
                            class="h-100"
                            [src]="data.thumbnailUrl()"
                            (error)="data.handleImageError()"
                            alt="image slide"
                        />
                    } @else {
                        <ng-container *ngTemplateOutlet="title; context: { $implicit: data }" />
                    }
                </div>
            </div>
        </div>
    
        <ng-container *ngTemplateOutlet="title; context: { $implicit: data }" />
    </div>
    
}
<!-- Reusable Title Template -->
<ng-template #title let-data>
  <div class="d-flex">
    <span class="primary-text font-5 my-2 text-center two-line-truncate">
        {{ data.code() ? data.code() + ' - ' + data.name() : data.name() }}
    </span>
  </div>
</ng-template>
